import { SectionHeader } from "@/components/SectionHeader";
export function IntegratedHeading() {
  return (
    <SectionHeader
      variant="centered"
      eyebrow="Thoughtfully integrated"
      title="Technology that complements the experience"
    />
  );
}

export function IntegratedParagraph() {
  return (
    <div className="max-w-xl space-y-6 text-sm leading-normal md:text-base tracking-body text-secondary">
      <p>
        Create rooms that feel natural and responsive, without more screens,
        steps, or instructions. Give guests control when they want it, and let
        the room respond when they don’t.
      </p>
      <p>
        Behind the scenes, we make it easier to deliver the experience you
        designed, consistently across every room.
      </p>
    </div>
  );
}
